<template>
  <div>
    <component :is="roleSpecificComponent"></component>
  </div>
</template>

<script>
export default {
  computed: {
    currentUser() {
      return this.$store.getters.currentUser;
    }
  },
  data() {
    return {
      roleSpecificComponent: null
    };
  },
  created() {
    // Dynamically import the component based on the user's role
    if (this.currentUser.role === 'player') {
      import('@/components/Customers/Bookings').then(module => {
        this.roleSpecificComponent = module.default;
      });
    } else if (this.currentUser.role === 'owner' || this.currentUser.role === 'admin' || this.currentUser.role === 'moderator') {
      import('@/components/Vendors/Bookings').then(module => {
        this.roleSpecificComponent = module.default;
      });
    } else {
      import('@/components/Customers/Bookings').then(module => {
        this.roleSpecificComponent = module.default;
      });
    }
  }
}
</script>